import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { ReturnStruct } from '../../structs/return.struct';
import { RecebimentoContasReceberRequest } from '../../requests/financas/recebimento-contas-receber.request';
import { PrepararRecebimentoContasReceberRequest } from '../../requests/financas/preparar-recebimento-contas-receber.request';
import { PrepararRecebimentoContasReceberResponse } from '../../responses/financas/preparar-recebimento-contas-receber.response';

@Injectable({
    providedIn: 'root'
})
export class RecebimentoContasReceberParcelaService extends CommonService {
    private readonly apiUrl: string = environment.urlApiFinancas + 'RecebimentoContasReceberParcela';

    constructor(private httpClient: HttpClient) {
        super();
    }

    public post(request: RecebimentoContasReceberRequest): Observable<ReturnStruct> {
        return this.httpClient
            .post<ReturnStruct>(this.apiUrl, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public preparar(request: PrepararRecebimentoContasReceberRequest): Observable<PrepararRecebimentoContasReceberResponse> {
        return this.httpClient
            .post<PrepararRecebimentoContasReceberResponse>(`${this.apiUrl}/preparar`, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}
